import http from '@/http';

export default {

    // CRUD
    update(id, form) {
        return http.put(`/deliverables/${id}/`, form);
    },
};



// WEBPACK FOOTER //
// ./src/api/deliverables.js